import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@kajabi/sage-react';
import { useCountryList } from '../hooks/useCountryList';

function CountryInput({
  id,
  label,
  value,
  onChange,
  placeholder,
  placeholderDisabled,
  disabled,
  hasError,
  message,
}) {
  const countryList = useCountryList();

  const placeholderOption = {
    disabled: placeholderDisabled,
    label: placeholder,
    value: '',
  };

  return (
    <Select
      id={id}
      data-testid={id}
      label={label}
      value={value}
      onChange={onChange}
      disabled={disabled}
      options={[placeholderOption, ...countryList]}
      hasError={hasError}
      message={message}
    />
  );
}

CountryInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  placeholderDisabled: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  message: PropTypes.string,
};

CountryInput.defaultProps = {
  label: '',
  value: '',
  disabled: false,
  placeholderDisabled: true,
  hasError: false,
  message: null,
};

export default CountryInput;
